import script from "./TiktokRecommon.vue?vue&type=script&lang=ts&setup=true"
export * from "./TiktokRecommon.vue?vue&type=script&lang=ts&setup=true"

import "./TiktokRecommon.vue?vue&type=style&index=0&id=141a4264&lang=scss"

const __exports__ = script;

export default __exports__